import React from 'react';
import { NavLink } from 'react-router-dom';

export interface GameNameCellProps {
  gameId: string | number;
  skuId: string | number;
  gameName: string;
  skuName: string;
  editable?: boolean;
}

function GameNameCell({ gameId, skuId, gameName, skuName, editable }: GameNameCellProps) {
  return (
    <div className="grid-game-name">
      <NavLink to={`/game/${gameId}`} className="game-title">
        {gameName}
      </NavLink>
      <br />
      <NavLink to={`/sku/${skuId}`}>{skuName}</NavLink>
    </div>
  );
}

export default GameNameCell;
